module.exports = __webpack_public_path__ + "static/img/data.a97ed149.png";